import { render, staticRenderFns } from "./_author_question.vue?vue&type=template&id=3a792d29"
import script from "./_author_question.vue?vue&type=script&lang=js"
export * from "./_author_question.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports